<template>
  <div class="booker">
      <p class="booker__description" v-if="numIBRooms > 0">
        <img src="../assets/img/icon-flash.svg" alt="Immediate booking" class="booker__icon">
        <span class="booker__emphasis">{{ numIBRooms }} {{ strings.rooms }} </span>{{ strings.availableforbooking }}.
      </p>
    </div>
</template>

<script>
export default {
    computed: {
        strings() {
            return this.$store.state.strings;
        },
        numIBRooms() {
            return this.$store.state.IBRooms.length;
        },
        isEnquiry() {
            return this.$store.state.showEnquiryForm;
        }
    }
}
</script>

<style>

</style>
